<div class="yes-no-indicator-content" *ngIf="data.length > 0">
    <div class="yes-no-indicator-item">
        <ng-container *ngFor="let periodValue of lstPeriodValue">
            <div 
            class="yes-no-indicator-container"
            [ngClass]="[periodValue?.labelConfig?.highlight ? 'yes-no-indicator-attention' : '']"
            >
                <span *ngIf="periodValue != null" class="yes-no-indicator-txt" [ngClass]="[periodValue?.displayText === TitleType.schedule ? 'oral_schd_f_size' : '']">
                    {{periodValue?.displayText || ""}}
                </span>
            </div>
        </ng-container>
    </div>
</div>

